<script lang="ts">
import { computed, defineComponent, onMounted, ref } from 'vue';

import Checkbox from '@/components/base/form/Checkbox.vue';
import Radio from '@/components/base/form/Radio.vue';

export default defineComponent({
  name: 'CreateAccount',
  props: {
    cxCreateAccount: { required: false, type: Boolean },
    isB2b: { required: false, type: Boolean, default: false },
  },
  components: {
    Checkbox,
    Radio,
  },
  emits: ['update:cxCreateAccount', 'update:isB2b'],
  setup(props, { emit }) {
    const showAccountType = ref(true);
    const createAccount = computed({
      get: () => props.cxCreateAccount,
      set: (val) => emit('update:cxCreateAccount', val),
    });
    const isB2bCustomer = computed({
      get: () => props.isB2b,
      set: (val) => emit('update:isB2b', val),
    });

    onMounted(async () => {
      if (props.isB2b) showAccountType.value = false;
    });

    return {
      createAccount,
      isB2bCustomer,
      showAccountType,
    };
  },
});
</script>

<template>
  <div data-test="cx-create-account">
    <strong class="mr-2 text-base leading-5">Create Account</strong>
    <div>
      <Checkbox
        v-model="createAccount"
        class="text-base font-normal"
        data-test="cx-create-account-checkbox"
      >
        Create account on customer's behalf
      </Checkbox>
      <div
        v-if="showAccountType"
        class="flex mt-3"
        aria-label="Account Type"
        data-test="account-type-selector"
        role="radiogroup"
      >
        <div class="mr-4 text-base">
          <Radio
            v-model="isB2bCustomer"
            aria-label="Personal"
            name="account-type"
            :value="false"
            class="radio-label"
          >
            Personal
          </Radio>
        </div>
        <div class="mr-4 text-base">
          <Radio
            v-model="isB2bCustomer"
            aria-label="Business"
            name="account-type"
            :value="true"
            class="radio-label"
          >
            Business
          </Radio>
        </div>
      </div>
      <div class="mt-2 text-xs text-neutral-500">
        Check out faster, track packages, create favorites &amp; more!
      </div>
    </div>
  </div>
</template>
